import { SearchHubspotCompaniesResponseSchema } from './search-hubspot-companies.schema';
/**
 * Search HubSpot Companies Endpoint Contract
 * Free-text picker for assigning a company to an account. Super-admin only.
 */ export const searchHubspotCompaniesContract = {
    method: 'GET',
    path: '/api/v2/admin/hubspot-companies',
    description: 'Search HubSpot companies by name or domain, for assignment',
    responseSchema: SearchHubspotCompaniesResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - invalid or missing token',
            403: 'Forbidden - not a super-admin',
            502: 'Bad Gateway - HubSpot API request failed'
        }
    }
};

//# sourceMappingURL=search-hubspot-companies.contract.js.map